module.exports = __webpack_public_path__ + "static/img/home_logo_004.15d13578.png";